import moment from "moment";
import { Box, IconButton, Paper, Typography, styled } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';

export const OHWrapper = styled(Box)({
    backgroundColor: "#F8F9FA",
    // border: "1px solid red",
    height: "100%"
})

export const OHPaper = styled(Paper)({
    height: "75vh",
    margin: "0px 24px",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    border: "4px 4px 4px 4px",
})

export const OverrideLeaveDates = (props: any) => {

    const { selectedLeaveDates, setSelectedLeaveDates } = props

    return (
        <Box sx={{ flex: 2 }}>
            <Box sx={{ width: "100%", height: "12%", border: "1px solid #E4E4E3", display: "flex", alignItems: "center", paddingLeft: "20px" }}>
                <Typography fontSize={16} fontWeight={500}>
                    Override Dates
                </Typography>
            </Box>
            <Box sx={{ width: "100%", }}>
                {selectedLeaveDates?.map((leaveDate: any) => (
                    <Box sx={{ width: "100%", display: "flex", padding: "10px 20px", borderBottom: "1px solid #E4E4E3", alignItems: "center", justifyContent: "space-between" }}>
                        {/* <Box sx={{ display: "flex", width: "100%", alignItems: "center" }}> */}
                        <Box sx={{ display: "flex" }}>
                            <Typography sx={{ width: "30px" }} fontSize={28} fontWeight={500}>
                                {moment(leaveDate).format("D")}
                            </Typography>
                            <Box sx={{ display: "flex", flexDirection: "column", marginLeft: "15px" }}>
                                <Typography sx={{ whiteSpace: "nowrap" }} fontSize={14} fontWeight={500}>
                                    {moment(leaveDate).format("MMMM YYYY")}
                                </Typography>
                                <Typography fontSize={12} fontWeight={500}>
                                    {moment(leaveDate).format("dddd")}
                                </Typography>
                            </Box>
                        </Box>
                        <IconButton onClick={() => setSelectedLeaveDates([...selectedLeaveDates].filter((leaveDateTemp: any) => leaveDateTemp !== leaveDate))}>
                            <DeleteIcon />
                        </IconButton>
                        {/* </Box> */}
                    </Box>
                ))}
            </Box>
        </Box>
    )
}